import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import Skeleton from "@material-ui/lab/Skeleton";
import { Product } from "../../model/product";

const useStyles = makeStyles({
  root: {
    minWidth: 260,
    maxWidth: 260,
    minHeight: 430,
  },
  media: {
    height: 250,
    backgroundSize: "contain",
  },
  content: {
    flex: "1 0 auto",
  },
  placeholder: {
    height: 300,
    width: "100%",
    backgroundColor: "rgb(0, 0, 0, 0.05)",
  },
  placeholderIcon: {
    fontFamily: "Alko_VK_websymbolit",
    opacity: 1,
    fontSize: 90,
    color: "rgba(255, 255, 255, 0.8)",
  },
  placeholderText: {
    color: "rgba(0, 0, 0, 0.6)",
  },
});

interface Props {
  product?: Product | null;
}

const PlaceHolderCard = () => {
  const classes = useStyles();
  return (
    <Card className={classes.root} elevation={2}>
      <Box p={2} className={classes.placeholder} display="flex" alignItems="center" justifyContent="center">
        <Box className={classes.placeholderIcon}>{"D"}</Box>
      </Box>
      <CardContent className={classes.content}>
        <Typography gutterBottom variant="h6" className={classes.placeholderText}>
          <Skeleton variant="text" animation={false} />
          <Skeleton variant="text" animation={false} width="60%" />
        </Typography>
      </CardContent>
    </Card>
  );
};

export const ProductCard = ({ product }: Props): JSX.Element => {
  const classes = useStyles();
  if (!product) return <PlaceHolderCard />;

  return (
    <Card className={classes.root} elevation={2}>
      <Box p={2}>
        <CardMedia
          className={classes.media}
          image={`https://images.alko.fi/t_digipruuvi,f_auto/cdn/${product.id}`}
          title={product.name}
        />
      </Box>
      <CardContent className={classes.content}>
        <Typography gutterBottom variant="h6">
          {product.name} {product.volume.toLocaleString("fi")}l
        </Typography>
        <Typography variant="body2" color="textSecondary" component="p">
          Toimittaja: {product.distributor || product.agentName}
        </Typography>
      </CardContent>
    </Card>
  );
};
